// FILE: src/pages/ClientPortal/ClientCarePlan.jsx
import React, { useEffect, useState, useCallback } from 'react';
import { clientPortalAPI } from '../../api/services';
import { toast } from 'react-toastify';
import './ClientPortal.css';

const fmtDate = (d) => d ? new Date(d).toLocaleDateString('en-US',{year:'numeric',month:'long',day:'numeric'}) : '—';

export default function ClientCarePlan() {
  const [plan,    setPlan]    = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const res = await clientPortalAPI.getCarePlan();
      setPlan(res.data.data || null);
    } catch { toast.error('Failed to load care plan.'); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <div className="cp-page">
      <div className="cp-header">
        <h1 className="cp-title">My Care Plan</h1>
        <p className="cp-subtitle">Your active care plan created by your case manager</p>
      </div>

      {loading ? <p style={{color:'#6b7280'}}>Loading care plan…</p>
       : !plan
       ? <div className="cp-empty">
           <div className="cp-empty-icon">📋</div>
           <div className="cp-empty-text">No active care plan</div>
           <div className="cp-empty-sub">Contact your case manager to set up your care plan.</div>
         </div>
       : (
          <div className="cp-careplan-card">
            {/* Active badge */}
            <div style={{ marginBottom: 16 }}>
              <span style={{ background:'#d1fae5', color:'#065f46', borderRadius:999, padding:'4px 14px', fontSize:12, fontWeight:700 }}>
                ✅ Active
              </span>
            </div>

            {/* Dates */}
            <div className="cp-careplan-dates">
              📅 {fmtDate(plan.StartDate)} — {fmtDate(plan.EndDate)}
            </div>

            {/* Created by */}
            {plan.CreatedByName && (
              <div style={{ fontSize:13, color:'#6b7280', marginBottom:18 }}>
                👤 Created by: <strong>{plan.CreatedByName}</strong>
              </div>
            )}

            {/* Summary */}
            {(plan.CareSummary || plan.Goals || plan.PlanTitle) && (
              <>
                <div style={{ fontSize:13, fontWeight:700, color:'#374151', marginBottom:8, textTransform:'uppercase', letterSpacing:'0.5px' }}>
                  Care Summary
                </div>
                <div className="cp-careplan-summary">
                  {plan.CareSummary || plan.Goals || plan.PlanTitle}
                </div>
              </>
            )}

            {/* Goals / Interventions (if separate fields) */}
            {plan.Goals && plan.CareSummary && (
              <div style={{ marginTop: 24 }}>
                <div style={{ fontSize:13, fontWeight:700, color:'#374151', marginBottom:8, textTransform:'uppercase', letterSpacing:'0.5px' }}>
                  Goals & Interventions
                </div>
                <div className="cp-careplan-summary">{plan.Goals}</div>
              </div>
            )}
          </div>
        )
      }
    </div>
  );
}
